export default "__VITE_ASSET__Ct2oH2kg__"